module.exports = __webpack_public_path__ + "static/media/brownie-points-logo-standard.df0ed2c7.svg";